import React from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { ActionButton, CardLayout, PageHeader } from "../../components/v3";
import { AddIncentiveForm } from "../../components/employee";
import { useNavigate } from "react-router-dom";

export const AddIncentive = () => {
  const navigate = useNavigate();
  return (
    <PageLayout>
      {/* header section */}
      <PageHeader
        // title
        title="Add Incentive"
        subtitle="Add incentive for employee"
      />

      {/* form */}
      <CardLayout>
        <AddIncentiveForm />
        <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
          <ActionButton buttonText="cancel" variant="outlined" onButtonClick={() => navigate(-1)} />
          <ActionButton buttonText="save" />
        </Box>
      </CardLayout>
    </PageLayout>
  );
};
